import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, adminAuth } from "@/lib/api";
import { TID } from "@/lib/testIds";
import { Sparkles, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      adminAuth.setToken(data.token);
      adminAuth.setEmail(data.email);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-ivory flex flex-col">
      <header className="p-6 md:p-10">
        <Link to="/" className="flex items-center gap-2">
          <Sparkles className="h-5 w-5 text-pebble" />
          <div className="h-display text-lg">Southern Utah Event Rentals</div>
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={submit} className="card-soft w-full max-w-md p-8 md:p-10">
          <div className="overline">Admin</div>
          <h1 className="h-display text-3xl mt-2">Sign in to your dashboard</h1>

          <div className="mt-8 space-y-5">
            <label className="block">
              <span className="overline block mb-2">Email</span>
              <input data-testid={TID.adminEmail} type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full h-12 rounded-2xl border border-stone bg-ivory px-4 focus:outline-none focus:ring-2 focus:ring-pebble transition-shadow" />
            </label>
            <label className="block">
              <span className="overline block mb-2">Password</span>
              <input data-testid={TID.adminPassword} type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full h-12 rounded-2xl border border-stone bg-ivory px-4 focus:outline-none focus:ring-2 focus:ring-pebble transition-shadow" />
            </label>
          </div>

          <button disabled={submitting} data-testid={TID.adminLoginBtn} className="btn-primary mt-8 w-full">
            {submitting ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in…</> : "Sign in"}
          </button>
          <Link to="/" className="block text-center text-sm text-graphite mt-6 hover:text-charcoal">← Back to site</Link>
        </form>
      </main>
    </div>
  );
}
